// extracted by mini-css-extract-plugin
module.exports = {"soonerWrapperColor":"toast_soonerWrapperColor__QoohS"};